/**
 * Mjuka värden — fördelar med batteri som inte syns i kr/år-siffran.
 *
 * Statisk komponent. Inte konfigurerbar. Saklig ton, inte säljig.
 * Syfte: påminna om att besparingen i kronor inte är hela bilden.
 */

interface SoftValue {
  title: string;
  body: string;
}

const VALUES: SoftValue[] = [
  {
    title: "Du slipper bevaka spotpriserna",
    body: "Batteriet arbitragerar automatiskt. Inget behov av att flytta tvätt, disk eller elbilsladdning till natten. Inte heller behöver du undvika att laga mat under kvällspeaken.",
  },
  {
    title: "Försäkring mot pristoppar",
    body: "Worst-case-vintrar med extrema spotpriser slår hårdare på de utan batteri. Värdet syns inte i en genomsnittlig årsbesparing utan i varianreduktionen mellan goda och dåliga elår.",
  },
  {
    title: "Reservkraft vid strömavbrott",
    body: "De flesta hybrid-växelriktare kan driva prioriterade kretsar (kyl, frys, värmepump, internet) i 4-24 timmar vid avbrott. Värdefullt för hemkontor, medicinsk utrustning, eller områden med tätare avbrott. Kräver att hybridväxelriktaren stöder ödrift, kontrollera med installatören.",
  },
  {
    title: "Mer värde av befintliga solpaneler",
    body: "Egenanvändning av solel ökar typiskt från 25-30% till 60-80%. Solpanelerna betalar sig snabbare, vilket är en separat besparing från batteriets eget värde.",
  },
  {
    title: "Bidrag till stabilare elnät",
    body: "Distribuerade batterier minskar nationella effekttoppar och behovet av reservkraft. Bidraget per hushåll är litet, men aggregerat över hundratusentals batterier märks det. Detta är värdet bortom din egen ekonomi.",
  },
];

export default function SoftValues() {
  return (
    <section className="soft-values">
      <h3>Värden utöver pengar</h3>
      <p className="hint">
        Allt går inte att räkna i kronor. Här är fem fördelar som inte syns i
        besparingssiffran ovan men som många batteriägare upplever som lika
        viktiga.
      </p>
      <ul>
        {VALUES.map((v) => (
          <li key={v.title}>
            <h4>{v.title}</h4>
            <p>{v.body}</p>
          </li>
        ))}
      </ul>
    </section>
  );
}
